import axios from "axios";
import { saveAs } from 'file-saver';

import {
    GET_FILE_LIST,
    UPLOAD_FILE,
    IMPORT_FILE_SET_LOADING,
    UPLOAD_FILE_SET_LOADING,
    IMPORT_FILE_DATA,
    UPLOAD_FILE_ERROR,
    IMPORT_FILE_ERROR,
    DELETE_FILE,
    GET_FOUR_FIFTH_FILES,
    GET_FOUR_FIFTH_FILES_ERROR,
    POST_FOUR_FIFTH_FILE,
    POST_FOUR_FIFTH_FILE_ERROR,
    IMPORT_FOUR_FIFTH_FILE_ERROR, IMPORT_FOUR_FIFTH_FILE, CLEAR_ERROR
} from './types'
import {
    DELETE_IMPORTED_FOURTH_FIFTH_FILE, ERROR_DELETE_IMPORTED_FOURTH_FIFTH_FILE,
    GET_EXCEL_TEMPLATE,
    GET_FILES_TO_CALCULATE,
    GET_FILES_TO_CALCULATE_ERROR,
    MODIFY_SINGLE_FILE,
    POST_FILES_TO_CALCULATE,
    POST_FILES_TO_CALCULATE_ERROR
} from "./actions";

// getFile list xlsx
export const getFileList = () => async (dispatch) => {
    dispatch({type: UPLOAD_FILE_SET_LOADING})

    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
        const response = await axios.get(process.env.REACT_APP_UPLOAD_FILE, config);

        dispatch({
            type: GET_FILE_LIST,
            payload: response.data
        })

    } catch (err) {
        console.log("error: ", JSON.stringify(err))
    }
}


// upload xlsx
export const uploadFile = (xlsxFile) => async (dispatch) => {

    dispatch({type: UPLOAD_FILE_SET_LOADING})

    const config = {
        // responseType: 'arraybuffer',
        responseType: 'json',
        headers: {
            'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");


    try {
        const response = await axios.post(process.env.REACT_APP_UPLOAD_FILE, xlsxFile, config);
        dispatch({
            type: UPLOAD_FILE,
            payload: response.data
        })

    } catch (err) {
        console.log("error: ", JSON.stringify(err))
        dispatch({
            type: UPLOAD_FILE_ERROR,
            error: err.response?err.response.data:true
        })
    }
}

// upload xlsx
export const importFileData = (fileID) => async (dispatch) => {

    dispatch({type: IMPORT_FILE_SET_LOADING})

    const config = {
        headers: {
            'Content-Type': 'application/json',

        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");


    try {
        const response = await axios.post(`${process.env.REACT_APP_UPLOAD_FILE}${fileID}/import_data_from_file/`, null, config);

        dispatch({
            type: IMPORT_FILE_DATA,
            payload: response.data
        })


    } catch (err) {
        console.log("error: ", JSON.stringify(err))
        dispatch({
            type: IMPORT_FILE_ERROR,
        })
    }
}

export const deleteFile = (fileID) => async (dispatch) => {
    dispatch({type: UPLOAD_FILE_SET_LOADING})

    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': "JWT " + localStorage.getItem("token")
        },
    };

    try {
        const response = await axios.delete(`${process.env.REACT_APP_UPLOAD_FILE}${fileID}/`, config);

        dispatch({
            type: DELETE_FILE,
            payload: response.data,
            id: fileID
        })


    } catch (err) {
        dispatch({
            type: UPLOAD_FILE_ERROR,
            payload: err
        })
    }
};

export const getCalculateFiled = () => async (dispatch) => {

    dispatch({type: UPLOAD_FILE_SET_LOADING})

    const config = {
        headers: {
            'Content-Type': 'application/json',

        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");


    let response = null;
    try {
        response = await axios.get(process.env.REACT_APP_GET_CALCUALATE_FILE, config);

        dispatch({
            type: GET_FILES_TO_CALCULATE,
            payload: response.data
        })


    } catch (err) {
        dispatch({
            type: GET_FILES_TO_CALCULATE_ERROR,
            payload: err
        })
    }
    return response;
};

export const getSingleFile = (fileID) => async (dispatch) => {

    const config = {
        headers: {
            'Content-Type': 'application/json',

        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    let response = null;
    try {
        response = await axios.get(`${process.env.REACT_APP_GET_CALCUALATE_FILE}${fileID}`, config);

        dispatch({
            type: MODIFY_SINGLE_FILE,
            payload: response.data
        })
    } catch (err) {
        console.error(err);
    }
    return response;
};


export const postCalculateFiled = (fileID) => async (dispatch) => {

    dispatch({type: IMPORT_FILE_SET_LOADING})

    const config = {
        headers: {
            'Content-Type': 'application/json',

        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");


    try {
        const response = await axios.post(`${process.env.REACT_APP_GET_CALCUALATE_FILE}${fileID}/calculate/`, null, config);

        dispatch({
            type: POST_FILES_TO_CALCULATE,
            payload: response.data
        })

        return 'Fields calculated successfully';


    } catch (err) {
        console.log("error: ", JSON.stringify(err))
        dispatch({
            type: POST_FILES_TO_CALCULATE_ERROR,
            payload: err
        })
        return 'Error calculating fields';
    }
};


// /api/get_template_excel

export const getTemplateExcel = () => async (dispatch) => {

    const config = {
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");
    try {

        const res = await axios.get(process.env.REACT_APP_GET_EXCEL_TEMPLATE, config);
        let blob = new Blob([res.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            saveAs(blob, 'PLIK DO WPROWADZANIA DANYCH PRZEZ ŚWIADCZENIODAWCÓW.xlsx');

        dispatch({
            type: GET_EXCEL_TEMPLATE,
            payload: res.data
        })


    } catch (err) {
        console.log("error: ", JSON.stringify(err))
    }

};




// getFile list xlsx
export const getFourFifthFileList = () => async (dispatch) => {
    dispatch({type: UPLOAD_FILE_SET_LOADING})

    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
        const response = await axios.get(process.env.REACT_APP_FOUR_FIVE_FILES, config);

        dispatch({
            type: GET_FOUR_FIFTH_FILES,
            payload: response.data
        })

    } catch (err) {
        console.log("error: ", JSON.stringify(err))
        dispatch({
            type: GET_FOUR_FIFTH_FILES_ERROR,
            payload: err
        })
    }
}


// upload xlsx
export const uploadFourFifthFile = (xlsxFile) => async (dispatch) => {

    dispatch({type: UPLOAD_FILE_SET_LOADING})

    const config = {
        responseType: 'json',
        // responseType: 'arraybuffer',
        headers: {
            // 'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            // 'Content-Type': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");


    try {
        const response = await axios.post(process.env.REACT_APP_FOUR_FIVE_FILES, xlsxFile, config);
        dispatch({
            type: POST_FOUR_FIFTH_FILE,
            payload: response.data
        })


    } catch (err) {
        console.log("error: ", JSON.stringify(err))
        dispatch({
            type: POST_FOUR_FIFTH_FILE_ERROR,
            payload: err
        })
    }
}
export const deleteFourFifthFile = (id) => async (dispatch) => {


    const config = {
        responseType: 'json',
        // responseType: 'arraybuffer',
        headers: {
            // 'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'Content-Type': 'application/json',
        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");


    try {
        const response = await axios.delete(process.env.REACT_APP_FOUR_FIVE_FILES+id+"/", config);
        dispatch({
            type: DELETE_IMPORTED_FOURTH_FIFTH_FILE,
            payload: id
        })


    } catch (err) {
        console.log("error: ", JSON.stringify(err))
        dispatch({
            type: ERROR_DELETE_IMPORTED_FOURTH_FIFTH_FILE,
            payload: err
        })
    }
}

// upload xlsx
export const importFourFifthFileData = (fileID) => async (dispatch) => {

    dispatch({type: IMPORT_FILE_SET_LOADING})

    const config = {
        responseType: 'json',
        // responseType: 'arraybuffer',
        headers: {
            // 'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'Content-Type': 'application/json',
        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");


    try {
        const response = await axios.post(`${process.env.REACT_APP_FOUR_FIVE_FILES}${fileID}/importer/`, null, config);
        dispatch({
            type: IMPORT_FOUR_FIFTH_FILE,
            payload: response.data,
            id: fileID
        })


    } catch (err) {
        dispatch({
            type: IMPORT_FOUR_FIFTH_FILE_ERROR,
            payload: err.response.data
        })
    }
}

export const clearError = () => async (dispatch) => {

    dispatch({type: CLEAR_ERROR})

}

export const getTemplateCodesExcel = () => async (dispatch) => {

    const config = {
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");
    try {

        const res = await axios.get(process.env.REACT_APP_GET_CODES_TEMPLATE, config);
        let blob = new Blob([res.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            saveAs(blob, 'Plik do zdefiniowania kont zespołu 4 i 5 przez świadczeniaodawcę.xlsx');

        dispatch({
            type: GET_EXCEL_TEMPLATE,
            payload: res.data
        })


    } catch (err) {
        console.log("error: ", JSON.stringify(err))
    }

};